import React from 'react'
import { Row, Card, Collapse, Col } from 'antd'

const { Panel } = Collapse

const CrainsDetriotBusiness = () => {
  return (
    <div className="crains-detriot-business-screen">
      <Row justify="center">
        <Card className="crains-detriot-business-card">
          <article>
            <h1 className="crains-detriot-business-title">CRAIN&apos;S DETROIT BUSINESS</h1>
            <hr />
            <br />
            <p>
              <b>
                You may not reproduce, display on a website, distribute, sell or republish this article or data, or the
                information contained therein, without prior written consent. This printout and/or PDF is for personal
                usage only and not for any promotional usage. © Crain Communications Inc.
              </b>
            </p>
            <p>
              July 01, 2021 07:51 AM | <b>UPDATED 6 HOURS AGO</b>
            </p>

            <h5>How a tiny New Jersey insurer is trying to break into Michigan&apos;s auto insurance market</h5>

            <figure className="right">
              <img alt="Eric Poe - CURE auto insurance" src="https://assets.cure.com/img/main-site/Eric.png" />
              <figcaption>Eric S. Poe, Esq., CPA</figcaption>
            </figure>

            <p>
              <b>CHAD LIVENGOOD</b>
            </p>
            <p>
              <b>•</b> 28 new auto insurance companies gain state regulatory approval to sell policies in MI
            </p>
            <p>
              <b>•</b> 2019 no-fault auto insurance reform law&apos;s reforms aimed to attract more competition
            </p>
            <p>
              <b>•</b> Small New Jersey-based auto insurer lands sponsorship deal with Detroit Pistons
            </p>
            <br />

            <Col>
              <section>
                <Collapse
                  accordion
                  className="crains-detriot-business-container p-margin-bottom-15"
                  defaultActiveKey={['panel1']}
                  expandIcon={({ isActive }) => (isActive ? null : null)}
                  expandIconPosition="right"
                >
                  <Panel
                    key="panel1"
                    className={'crains-detriot-business-panel'}
                    collapsible="disabled"
                    forceRender="true"
                    header="NEW AUTO INSURERS ENTER MICHIGAN MARKET"
                    style={{ fontSize: '1.2rem' }}
                  >
                    <div className="faq-panel-Auto-Damage-text-content">
                      <p>
                        Since Gov. Gretchen Whitmer signed a law overhauling Michigan&apos;s auto insurance law in May
                        2019, 28 insurance carriers have filed with the Michigan Department of Insurance and Financial
                        Services to do business in the state. Just six carriers to date have had their insurance rates
                        and forms approved by DIFS to write policies in the state. Prior to the law change, there were
                        107 insurers writing auto no-fault policies in Michigan, according to DIFS.
                      </p>
                      <p>➡ ACMI Auto Insurance Co</p>
                      <p>➡ American Builders Insurance Co.</p>
                      <p>➡ Arch Indemnity Insurance Co.</p>
                      <p>➡ Arch Property Casualty Insurance Co. (personal auto)*</p>
                      <p>➡ Arch Property Casualty Insurance Co. (commercial auto)*</p>
                      <p>➡ Berkley Insurance Co.*</p>
                      <p>➡ Branch Insurance Exchange</p>
                      <p>➡ Citizens United Reciprocal Exchange (CURE)*</p>
                      <p>➡ Dairyland National Insurance Co.</p>
                      <p>➡ Dairyland National Insurance Co.</p>
                      <p>➡ ECMI Auto Insurance Co.</p>
                      <p>➡ ESMI Auto Insurance Co.</p>
                      <p>➡ Everspan Insurance Co.</p>
                      <p>➡ Incline Casualty Co.</p>
                      <p>➡ Insurance Company of the South</p>
                      <p>➡ Liberty Mutual Insurance Co.*</p>
                      <p>➡ Liberty Mutual Personal Insurance Co.*</p>
                      <p>➡ Mobilitas General Insurance Co.</p>
                      <p>➡ Nationwide Affinity Insurance Company of America</p>
                      <p>➡ National Builders Insurance Co.</p>
                      <p>➡ Professional Solutions Insurance Co.</p>
                      <p>➡ ProTucket Insurance Co.</p>
                      <p>➡ Rock Ridge Insurance Co.</p>
                      <p>➡ Universal Fire & Casualty Insurance Co.</p>
                      <p>➡ Westfield Champion Insurance Co.</p>
                      <p>➡ Westfield Premier Insurance Co.</p>
                      <p>➡ Westfield Superior Insurance Co.</p>
                      <p>➡ Westfield Touchstone Insurance Co.</p>
                    </div>
                  </Panel>
                </Collapse>
              </section>
            </Col>

            <p>
              The state Legislature&apos;s 2019 overhaul of Michigan&apos;s unique no-fault auto insurance law has
              attracted 28 new carriers to potentially join the market as the reform measure promises to drive down the
              financial liability exposure of insurance companies.
            </p>
            <p>
              However, just six of those companies or their affiliates have rate filings that have been approved by the
              Michigan Department of Insurance and Financial Services, according to the agency.
            </p>
            <p>
              Boston-based Liberty Mutual Insurance Co. and its affiliate Liberty Mutual Personal Insurance Co. is the
              biggest national brand name to have its rates approved by DIFS for selling auto insurance policies in
              Michigan.
            </p>
            <p>
              Columbus-based Nationwide Affinity Insurance Co. of America is among the 22 other new carriers approved
              for doing business in the state, but it hasn&apos;t filed a rate plan yet with DIFS, according to state
              regulators.
            </p>
            <p>
              While Liberty and Nationwide bring well-established brand names with familiar national TV advertising
              campaigns, most of the new carriers that have gotten approval from the state to write policies in Michigan
              are smaller insurers looking to get a foothold in a market of nearly 7 million vehicles on the road.
            </p>
            <p>
              While Liberty and Nationwide bring well-established brand names with familiar national TV advertising
              campaigns, most of the new carriers that have gotten approval from the state to write policies in Michigan
              are smaller insurers looking to get a foothold in a market of nearly 7 million vehicles on the road.
            </p>

            <p>
              Gaining some name recognition is the first big hurdle, said Eric Poe, CEO of CURE Auto Insurance, a
              Princeton, N.J.-based carrier that is starting to write policies in Michigan on Thursday. (CURE stands for
              Citizens United Reciprocal Exchange).
            </p>

            <p>
              To help his company get started, Poe signed a deal with the Detroit Pistons to make CURE Auto Insurance
              the official sponsor of the Pistons&apos; post-game press conference backdrop for home and away games.
            </p>

            <p>Terms of the agreement were not disclosed by CURE or the Pistons.</p>
            <p>
              But the CEO of CURE suggested his company was able to afford such a sponsorship, in part, because the
              Pistons finished at the bottom of the Eastern Conference this season with just 20 wins (the same number of
              wins the Pistons notched in the pandemic shortened 2019-20 season).
            </p>
            <p>
              CURE has had similar smaller-dollar sponsorships in the past with the Philadelphia 76ers and the New
              Jersey Nets before they moved to Brooklyn, when both teams were in rebuilding mode like the Pistons are,
              Poe said.
            </p>

            <p>
              &quot;I think there&apos;s a lot of promising things going on with the Pistons,&quot; Poe told
              Crain&apos;s. &quot;So, I kind of believe in the model of buy low, sell high, and I feel like the Pistons
              are buy low right now.&quot;
            </p>

            <p>
              Poe hopes his company can gain some name recognition in the market with its logo on TV during post-game
              press conferences featuring Pistons forwards Jerami Grant and Saddiq Bey or the expected star rookie the
              team will get with the No. 1 pick in the NBA draft on July 29.
            </p>
            <p>
              CURE also has signed a five-year deal with former Pistons &quot;Bad Boy&quot; Rick Mahorn to be a brand
              ambassador for the auto insurer. Mahorn, 62, likely also has some name recognition in CUREs New Jersey and
              Philadelphia markets, having also played for the 76ers and the Nets after winning the NBA championship
              with the Pistons in 1989.
            </p>
            <p>
              To be sure, CURE is a David compared to a Goliath like Liberty Mutual, which had $145 billion in assets at
              the end of 2020, according to its annual financial report.
            </p>
            <p>
              CURE, a family-owned regional auto insurance carrier with about $45 million in assets, insures 40,000
              vehicles in New Jersey and just fewer than 5,000 vehicles in Pennsylvania, mostly just over the Delaware
              River from New Jersey in the Philadelphia market, Poe said.
            </p>
            <p>
              Poe said he sees an opportunity to grow in Michigan, particularly in Detroit where an estimated half of
              the city&apos;s motorists have been driving without insurance for years because of the annual cost of
              insuring a vehicle has reached $6,000 — double the state-wide average.
            </p>
            <p>
              Michigan&apos;s recent auto insurance reforms, Poe said, &quot;will transform Michigan — at least in our
              opinion — from arguably the worst state for car insurance in the country to one of the best-performing
              states for car insurance in the country because there will be no debate over what the reasonable rate
              is.&quot;
            </p>
            <p>The 2019 law rolled out changes to auto no-fault in two stages.</p>
            <p>
              The first stage took place last July when, for the first time, drivers were allowed to drop unlimited
              medical coverage, called Personal Injury Protection, on their auto insurance policies if they have
              Medicare or a health insurance plan that covers auto injuries. Motorists also were able to elect a cap of
              $500,000 or $250,000 on PIP coverage, resulting in reductions on the PIP portion of a driver&apos;s
              insurance premiums of 35 percent and 20 percent, respectively.
            </p>
            <p>
              The second stage of the 2019 law kicks in Thursday with the implementation of a first cap on payments to
              medical providers for treating injured motorists.
            </p>

            <p>
              That so-called fee schedule caps medical procedures with a Medicare billing code at 200 percent of what
              Medicare pays and imposes a 55 percent cap on home health care services and rehabilitation clinic care
              that isn&apos;t covered by the federal health insurance program for senior citizens.
            </p>
            <p>
              Poe said the fee schedule brings financial certainty to insurers so they know they&apos;ll have stability
              in the cost of certain medical procedures and know that the care will be necessary.
            </p>
            <p>
              &quot;What people don&apos;t realize is that when you have no reasonableness of rates, you create a pot of
              gold at the end of the rainbow for people to overtreat,&quot; Poe said. &quot;You&apos;ll have no
              overtreatment when people don&apos;t have an incentive to overtreat.&quot;
            </p>

            <p>
              Going forward, Poe said, the fee schedule will guard against &quot;rabid abuse&quot; in medical billing
              for injured motorists.
            </p>
            <p>
              &quot;We believe that there&apos;s an underserved market&quot; in Michigan, Poe said. &quot;We believe the
              fee schedule is going to have a significant impact.&quot;
            </p>

            <p>
              The new law also bans the use of certain nondriving factors for setting auto insurance rates, prohibiting
              insurers from penalizing a motorist for not having a college degree, for example.
            </p>
            <p>
              Poe has advocated across the country for outlawing the use of insurance rating-setting factors that have
              nothing to do with whether a motorist is a good driver.
            </p>
            <p>
              He is familiar face to Detroit Mayor Mike Duggan&apos;s administration. Poe previously consulted the
              mayor&apos;s office on some of the framework for banning nondriving factors during Duggan&apos;s early
              attempts to convince lawmakers to overhaul the no-fault insurance law.
            </p>
            <p>
              The law prohibits the use of FICO credit scores for rate-setting, though it still allows insurers to
              develop their own assessment for scoring a driver&apos;s creditworthiness, Poe said.
            </p>
            <p>
              &quot;It&apos;s a little misleading to say this is helping consumers that have bad credit scores because
              my industry just puts one or two more components on a credit score and dresses up a pig and says,
              &apos;Hey, this a proprietary score.&apos; That is still being permitted to use,&quot; Poe said.
            </p>
            <p>
              CURE Auto Insurance, however, does not use credit ratings in any fashion for setting its rates, Poe said.
            </p>
            <p>Inline Play</p>

            <hr />
            <p className="crains-detriot-business-foot-note">
              <b>Source URL:</b>
              <a
                className="crains-detriot-business-hyperlinks"
                href="https://www.crainsdetroit.com/insurance/how-tiny-new-jersey-insurer-trying-break-michigans-auto-insurance-market"
                rel="noreferrer"
                target="_blank"
              >
                {' '}
                https://www.crainsdetroit.com/insurance/how-tiny-new-jersey-insurer-trying-break-michigans-auto-insurance-market
              </a>
            </p>
          </article>
        </Card>
      </Row>
    </div>
  )
}

CrainsDetriotBusiness.propTypes = {}

export default CrainsDetriotBusiness
